// CustomDatePicker.js
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';

/**
 * 
 * CustomDatePicker component for selecting date ranges.
 * @pisAnnual {boolean} - Determines if the date picker is for annual data.
 * @startDate {Date} - The start date of the range.
 * @endDate {Date} - The end date of the range.
 * @onChange {function} - Callback function to handle date changes.
 * @returns DatePicker component with custom styles and functionality.
 */
function CustomDatePicker({ isAnnual, startDate, endDate, onChange }) {
  const currentDate = new Date();
  const minDate = new Date(1900, 0, 1);
  // Set max date to the end of the current month or year
  // depending on whether the picker is annual or monthly
  const maxDate = new Date(currentDate.getFullYear(), isAnnual ? 11 : currentDate.getMonth(), 31);

  return (
    <DatePicker
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      showYearPicker={isAnnual}
      showMonthYearPicker={!isAnnual}
      dateFormat={isAnnual ? 'yyyy' : 'MM/yyyy'}
      showYearDropdown
      inline
      minDate={minDate}
      maxDate={maxDate}
    />
  );
}

export default CustomDatePicker;
